import { useEvent as n } from "../../../ariakit-react-utils/esm/hooks.js";
import { createComponent as E, createElement as T, createHook as b } from "../../../ariakit-react-utils/esm/system.js";
import { usePopoverAnchor as g } from "../popover/popover-anchor.js";
const A = b((o) => {
  var a, f;
  let {
    state: e,
    described: i,
    ...t
  } = o;
  const c = t.onFocus, l = n((r) => {
    c == null || c(r), !r.defaultPrevented && (e.anchorRef.current !== r.currentTarget && (e.anchorRef.current = r.currentTarget, e.render()), e.show());
  }), u = t.onBlur, h = n((r) => {
    u == null || u(r), !r.defaultPrevented && e.hide();
  }), d = t.onMouseEnter, m = n((r) => {
    d == null || d(r), !r.defaultPrevented && (e.anchorRef.current !== r.currentTarget && (e.anchorRef.current = r.currentTarget, e.render()), e.show());
  }), s = t.onMouseLeave, p = n((r) => {
    s == null || s(r), !r.defaultPrevented && e.hide();
  });
  return t = {
    tabIndex: 0,
    "aria-labelledby": i || (a = e.contentElement) == null ? void 0 : a.id,
    "aria-describedby": i ? (f = e.contentElement) == null ? void 0 : f.id : void 0,
    ...t,
    onFocus: l,
    onBlur: h,
    onMouseEnter: m,
    onMouseLeave: p
  }, t = g({
    state: e,
    ...t
  }), t;
}), R = E((o) => {
  const e = A(o);
  return T("div", e);
});
process.env.NODE_ENV !== "production" && (R.displayName = "TooltipAnchor");
export {
  R as TooltipAnchor,
  A as useTooltipAnchor
};
//# sourceMappingURL=tooltip-anchor.js.map
